import { createLoader } from '@meteor/data-hooks';
import { useCurrentProject } from '../../instance';
import { withAuth } from '../../user';
import { organizationClient } from '../client';
import { useCurrentOrganization } from './organization';

export let onboardingLoader = createLoader({
  name: 'onboarding',
  hash: h =>
    h.organizationId +
    h.projectId +
    h.onboardingGroupKey +
    h.tasks.map(t => t.key + t.status).join(''),
  fetch: async (i: {
    projectId: string;
    organizationId: string;
    onboardingGroupKey: string;
    tasks: {
      key: string;
      status: 'completed' | undefined;
    }[];
  }) => {
    return withAuth(() => organizationClient.onboarding.ensureGroup(i));
  },
  mutators: {
    skipGroup: (i: void, { input: { projectId, organizationId, onboardingGroupKey } }) =>
      withAuth(() =>
        organizationClient.onboarding.skipGroup({
          organizationId,
          projectId,
          onboardingGroupKey
        })
      ),

    completeTask: (
      i: { onboardingTaskKey: string },
      { input: { projectId, organizationId, onboardingGroupKey } }
    ) =>
      withAuth(() =>
        organizationClient.onboarding.task.complete({
          organizationId,
          projectId,
          onboardingGroupKey,
          onboardingTaskKey: i.onboardingTaskKey
        })
      ),

    dismissTask: (
      i: { onboardingTaskKey: string },
      { input: { projectId, organizationId, onboardingGroupKey } }
    ) =>
      withAuth(() =>
        organizationClient.onboarding.task.dismiss({
          organizationId,
          projectId,
          onboardingGroupKey,
          onboardingTaskKey: i.onboardingTaskKey
        })
      ),

    dismissAllTasks: (i: void, { input: { projectId, organizationId, onboardingGroupKey } }) =>
      withAuth(() =>
        organizationClient.onboarding.task.dismissAll({
          organizationId,
          projectId,
          onboardingGroupKey
        })
      )
  }
});

export let useOnboarding = (i: {
  onboardingGroupKey: string;
  tasks: {
    key: string;
    status: 'completed' | undefined;
  }[];
}) => {
  let project = useCurrentProject();
  let org = useCurrentOrganization();
  let onboarding = onboardingLoader.use(
    project.data?.id && org.data
      ? {
          projectId: project.data.id,
          organizationId: org.data.id,
          onboardingGroupKey: i.onboardingGroupKey,
          tasks: i.tasks
        }
      : null
  );

  return {
    ...onboarding,
    completeTaskMutator: onboarding.useMutator('completeTask'),
    dismissTaskMutator: onboarding.useMutator('dismissTask'),
    dismissAllTasksMutator: onboarding.useMutator('dismissAllTasks'),
    skipGroupMutator: onboarding.useMutator('skipGroup')
  };
};
